import * as React from "react";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { FACEBOOK_ICON, INSTAGRAM_ICON, TWITTER_ICON } from "../utils/svg_social";
import { AppIcon } from "./Generic/AppIcon";
import { AppList, AppListItem } from "./Generic/AppList";
import TrailingChevron from "./Generic/TrailingChevron/TrailingChevron";
import GenericSettingsScreen from "./GenericSettingsScreen";

interface SettingsSocialScreenProps {
  onClickGoBack: () => void;
}

const SettingsSocialScreen = (props: SettingsSocialScreenProps) => {
  const handleFacebookClick = React.useCallback(() => {
    openExternalUrl("https://www.facebook.com/medflyt/");
  }, []);

  const handleInstagramClick = React.useCallback(() => {
    openExternalUrl("https://www.instagram.com/medflyt/");
  }, []);

  const handleTwitterClick = React.useCallback(() => {
    openExternalUrl("https://twitter.com/medflyt");
  }, []);

  return (
    <GenericSettingsScreen title={translate(STRINGS.SOCIAL)} onClickGoBack={props.onClickGoBack}>
      <AppList bordered={true}>
        <AppListItem
          leading={<AppIcon icon={FACEBOOK_ICON} size={24} />}
          title={translate(STRINGS.LIKE_US_ON_FACEBOOK)}
          trailing={<TrailingChevron />}
          onClick={handleFacebookClick}
        />
        <AppListItem
          leading={<AppIcon icon={INSTAGRAM_ICON} size={24} />}
          title={translate(STRINGS.FOLLOW_US_ON_INSTAGRAM)}
          trailing={<TrailingChevron />}
          onClick={handleInstagramClick}
        />
        <AppListItem
          leading={<AppIcon icon={TWITTER_ICON} size={24} />}
          title={translate(STRINGS.FOLLOW_US_ON_TWITTER)}
          trailing={<TrailingChevron />}
          onClick={handleTwitterClick}
        />
      </AppList>
    </GenericSettingsScreen>
  );
};

export default React.memo(SettingsSocialScreen);
